<template>
    <div class="footer-container">
        <div class="footer-up bjfoot">
            <div class="footer-up-inner">
                <el-row style="padding: 0.7rem 0 !important">
                    <el-col :lg="8" :md="12" :xs="24">
                        <div class="fadeInDown hlj hlj-hover">
                            <a href="" class="news_libox">
                                <i
                                    class="iconfont icon-location"
                                    aria-hidden="true"
                                ></i
                                >地址：沈阳国际软件园B1-305
                            </a>
                        </div>
                    </el-col>
                    <el-col :lg="8" :md="12" :xs="24">
                        <div class="fadeInDown hlj hlj-hover">
                            <a href="" class="news_libox hover-color">
                                <i
                                    class="iconfont icon-lianjie"
                                    aria-hidden="true"
                                ></i
                                >平台网址：www.motic-et.com
                            </a>
                        </div>
                    </el-col>
                    <el-col :lg="8" :md="12" :xs="24">
                        <div class="fadeInDown hlj hlj-hover">
                            <a href="" class="news_libox hover-color">
                                <i
                                    class="iconfont icon-lianjie"
                                    aria-hidden="true"
                                ></i
                                >公司官网：www.motic-et.com.cn
                            </a>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="footer-down bjfoot2">
            <div class="footer-down-inner">
                <el-row>
                    <el-col
                        :lg="8"
                        :md="8"
                        :xs="24"
                        class="col-lg-4 col-md-6 col-xs-12"
                    >
                        <div
                            class="wow fadeInDown tel_adreea hljr"
                            data-wow-delay="0.2s"
                        >
                            <i
                                class="iconfont icon-dianhua1"
                                aria-hidden="true"
                            ></i>
                            <div>电话：400-0909-151<br>手机：13324059497</div>
                            <span
                                ><img
                                    src="../../assets/image/official/ewm1.jpg"
                                    alt=""
                                    width="22%"
                                    height="auto"
                            /></span>
                            <span
                                ><img
                                    src="../../assets/image/official/ewm2.jpg"
                                    alt=""
                                    width="22%"
                                    height="auto"
                            /></span>
                            <span
                                ><img
                                    src="../../assets/image/official/ewm3.jpg"
                                    alt=""
                                    width="22%"
                                    height="auto"
                            /></span>
                        </div>
                    </el-col>
                    <el-col :lg="16" :md="16" :xs="24">
                        <div class="wow fadeInDown hlj" data-wow-delay="0.2s">
                            <el-row>
                                <el-col :xs="24" :md="12" :lg="4">
                                    <div
                                        class="wow fadeInDown hlj"
                                        data-wow-delay="0.2s"
                                    >
                                        <h4>关于我们</h4>
                                        <a href="http://test.motic-et.com/static/web/about1.html">集团介绍</a>
                                        <a href="http://test.motic-et.com/static/web/about2.html">公司介绍</a>
                                        <a href="http://test.motic-et.com/static/web/about3.html">发展历程</a>
                                        <a href="http://test.motic-et.com/static/web/about4.html">公司资质</a>
                                        <a href="http://test.motic-et.com/static/web/news_rong1.html">能源课堂</a> 
                                        <a href="http://test.motic-et.com/static/web/about6.html">常见问题</a>  
                                    </div>
                                </el-col>
                                <el-col :xs="24" :md="12" :lg="4">
                                    <div
                                        class="wow fadeInDown hlj"
                                        data-wow-delay="0.2s"
                                    >
                                        <h4>产品中心</h4>
                                        <a href="http://test.motic-et.com/static/web/pro_rong7.html">集中器</a>
                                        <a href="http://test.motic-et.com/static/web/pro_rong1.html">采集器</a>
                                        <a href="http://test.motic-et.com/static/web/products.html">更多</a>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :md="12" :lg="4">
                                    <div
                                        class="wow fadeInDown hlj"
                                        data-wow-delay="0.2s"
                                    >
                                        <h4>平台中心</h4>
                                        <a href="http://test.motic-et.com/static/web/xitong1.html">数据采集服务</a>
                                        <a href="http://test.motic-et.com/static/web/xitong2.html">数据分析服务</a>
                                        <a href="http://test.motic-et.com/static/web/xitong3.html">政府能管服务</a>
                                        <a href="http://test.motic-et.com/static/web/xitong4.html">售电管理服务</a>
                                         <a href="http://test.motic-et.com/static/web/xitong5.html">能效分析节能服务</a>
                                          <a href="http://test.motic-et.com/static/web/xitong6.html">用能安全管理服务</a>
                                          <a href="http://test.motic-et.com/static/web/xitong7.html">电力智能运维管理服务</a>
                                    <a href="http://test.motic-et.com/static/web/xitong8.html">园区能源管理服务</a> 
                                    </div>
                                </el-col>
                                 
                                <el-col :xs="24" :md="12" :lg="4">
                                    <div
                                        class="wow fadeInDown hlj"
                                        data-wow-delay="0.2s"
                                    >
                                        <h4>能源大数据</h4>
                                        <a href="https://www.motic-et.com/motic_center/bigScreen/index.html">麦克奥迪能源科技大数据展示</a>
                                        <a href="http://qydp.motic-et.com/BigScreenOne">翔安工业园能源大数据展示</a>
                                        <a href="hhttps://www.motic-et.com/motic_center/cooperativePartner/energy.do">沈阳市能源大数据展示</a>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
                 <el-row style="padding: 0.7rem 0 !important">
                    <el-col :lg="24" :md="24" :xs="24">
                        <div class="fadeInDown foot_lianji">
                        友情链接： 
                             <a  href="http://www.motic-et.com.cn" >麦克奥迪能源科技</a> <a
                                href="http://www.zjxny56.com">中国能源物流产业网</a> <a
                                href="http://www.vipstar.com.cn">能源信息网</a> <a
                                href="http://www.localcn.net">能源环保资讯网</a> <a
                                href="http://www.cnxinnengyuan.com">中国新能源网</a>
                        </div>
                    </el-col> 
                </el-row>
                  
                <el-row>
                    <el-col :lg="24" :md="24" :xs="24">
                        <div
                            class="text-center col_copy"
                            style="border-top: 1px solid #4b4d51"
                        >          
                            沈阳麦克奥迪能源科技有限公司&nbsp;&nbsp;&nbsp;<a
                                class="wir_a"
                                target="_blank"
                                href="https://beian.miit.gov.cn/#/Integrated/index"
                                >辽公网安备 辽ICP备18002503号</a
                            >&nbsp;&nbsp;&nbsp;<a class="wir_a" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21011202000592">
                            <img src="../../assets/image/official/public_security_icon.png" align="absmiddle">&nbsp;&nbsp;辽公网安备 21011202000592号</a>
                            &nbsp;&nbsp;&nbsp;Copyright  2017 All Rights Reserved.
                        </div>  
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.footer-container {
    width: 100%;
    font-size: 0.8rem !important;
    .bjfoot {
        background: #212634;
    }
    .bjfoot2 {
        background: #252b3a;
    }
    .footer-up-inner {
        max-width: 1280px;
        margin: 0 auto;
        // height: 70px;
        // line-height: 70px;
    }
    .footer-down-inner {
        max-width: 1280px;
        margin: 0 auto;
    }
    .news_libox i {
        font-size: 20px;
        width: 30px;
        text-align: center;
        line-height: 30px;
        height: 30px;
        vertical-align: middle;
        margin-right: 20px;
        display: inline-block;
        border-radius: 50%;
        border: 1px solid #ebecec;
    }
    .bjfoot2 {
        background: #252b3a;
        padding: 20px 0;
    }
    .hlj {
        color: #fff;
        border-radius: 40px;
        padding: 0.3rem 0;
    }
       .foot_lianji{text-align:left;color:#f0f0f0;}
    .foot_lianji a{display:inline-block;color:#FFF;padding:0 0.5rem;}
    .hlj-hover {
        &:hover {
            box-shadow: 0px 0px 30px #666;
            .icon-lianjie {
                color: #e9895f;
            }
            .hover-color {
                color: #e9895f;
            }
        }
    }
    .tel_adreea {
        padding: 10px 0;
    }
    .tel_adreea span,
    .tel_adreea {
        text-align: center;
        display: block;
        text-align: center;
        width: 100%;
    }
    .tel_foot {
        font-size: 2.1rem !important;
        color: #ebecec;
        display: block !important;
        text-align: center;
    }
    .tel_adreea div {
        line-height: 2.1;
        font-size: 1.1rem;
        color: #ebecec;
        margin-bottom: 15px;
    }
    .hljr {
        border-right: 1px solid #393e4c;
        margin: 30px 0;
    }
    .hlj a {
        display: block;
        color: #ebecec;
        line-height: 2;
        font-size: 0.7rem;
    }
    .hlj h4 {
        font-size: 0.7rem;
        color: #ebecec;
        font-weight: normal;
        line-height: 3;
    }
    .foot_lianjie {
        color: #ebecec;
        border-top: 1px solid #393e4c;
        border-bottom: 1px solid #393e4c;
        line-height: 40px;
    }
    .foot_lianjie a {
        color: #fff;
    }
    .wir_a{color: #fff;}
    .tel_adreea span {
        width: 20%;
        display: inline-block;
        margin-right: 3%;
    }
    .tel_adreea span img {
        height: auto;
        width: 100%;
    }
    .col_copy {
        text-align: center;
        font-size: 0.65rem;
        line-height: 40px;
        color: #ebecec;
        width: 100%;
        overflow: hidden;
    }
    .icon-dianhua1 {
        font-size: 1.6rem;
        color: #fff;
    }
}
</style>
